import { FC } from 'react';
import { Else, If, Then } from '@edikk-edikk/if';
import PhotoWebp from '#srcImages/main-background/photo.webp';
import PhotoSmWebp from '#srcImages/main-background/photo-sm.webp';
import PhotoSxWebp from '#srcImages/main-background/photo-xs.webp';
import homeCss from '#srcCssModules/home/home.module.scss';
import { useHomeContext } from '#home/hooks';

const Background: FC = () => {
  const { mainImageUrl } = useHomeContext();

  return (
    <div className={homeCss.home__background}>
      <If condition={mainImageUrl}>
        <Then>
          <img src={mainImageUrl} alt="Main" fetchPriority="high" />
        </Then>
        <Else>
          <picture>
            <source
              media="(max-width: 799px)"
              srcSet={`${PhotoSxWebp} 1x, ${PhotoSmWebp} 2x, ${PhotoWebp} 3x`}
            />
            <img src={PhotoWebp} alt="Main" fetchPriority="high" />
          </picture>
        </Else>
      </If>
    </div>
  );
};

export { Background };
